import { ERC20ABI } from "@/config";
import { AppContext } from "@/context";
import { useExecuteSwapWithFee } from "@/hooks/executeSwapWithFee";
import useCalculateSlippageAmount from "@/hooks/useCalculateSlippageAmount";
import useFuncName from "@/hooks/useFuncName";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { chainId, isSlippage, privatekeyArray, rpc, spenToken, token } from "@/store";
import { addressHand, errorHandler } from "@/utils";
import { ERROR, Green } from "./MarketBotRight/StartBotHandler";
import { Notification } from "@/components";
import { useProviderInstance } from "@/context/ProviderContext";
import { useWalletInfoContext } from "@/context/WalletInfoContext";
import { createViemWallet } from "@/utils/createViemWallet";
import { to0xString } from "@/utils/toHex";
import { parseUnits } from "viem";
import { waitForTransactionReceipt } from "@wagmi/core";
import { chains, wagmiConfig } from "@/utils/wagmi";

export const swapHandle = () => {
  const { executeSwapWithFee } = useExecuteSwapWithFee();
  const _privatekeyArray = useSelector(privatekeyArray);
  const getFuncName = useFuncName();
  const _token = useSelector(token);
  const { walletConfig, tokenIsA } = useWalletInfoContext();
  const { calculateSlippageAmount } = useCalculateSlippageAmount();
  const _spenToken = useSelector(spenToken);
  const _isSlippage = useSelector(isSlippage);
  const { Lang } = useContext(AppContext);
  const _rpc = useSelector(rpc);
  const _chainId = useSelector(chainId);

  const executeSwapSingle = async (
    index: number,
    isBuy: boolean,
    Num: string,
    extraValue: string,
    WETHToken: any,
    poolKeyArray: string[],
    logHandler?: any,
  ) => {
    console.log('Num::: ', Num);
    const currentChain = chains.find(c => c.id === _chainId);
    try {
      const { walletClient: wallet, publicClient } = createViemWallet(_privatekeyArray[index], currentChain, _rpc)

      let { sellPaths, buyPaths, sellArg, buyArg, isSpenMianToken } = getFuncName(
        wallet,
        WETHToken,
      );

      // 根据操作类型选择路径
      const swapPath = isBuy ? buyPaths : sellPaths;

      // 2. 处理卖出/买入的金额逻辑
      let value = 0n
      let amountIn = 0n
      let amountOutMin = 0n
      let spendAmount: 0n;

      if (!isBuy) {
        // ---------- 卖出逻辑 ----------

        const balance = await publicClient.readContract({
          address: to0xString(_token?.address),
          abi: ERC20ABI,
          functionName: 'balanceOf',
          args: [wallet.account.address],
          authorizationList: undefined
        }) as bigint
        console.log('balance::: ', balance);

        if (Number(balance) === 0) {
          const msg = `${addressHand(wallet.account.address)}钱包代币余额为0`;
          logHandler ? logHandler(msg, "red") : Notification.Error(msg);
          return;
        }
        amountIn = balance; // 卖出金额为钱包余额
        console.log('amountIn::: ', Number(amountIn));

        if (_isSlippage) {

          const res = await calculateSlippageAmount(
            sellPaths,
            publicClient,
            balance,
            isBuy,
            poolKeyArray,
          );
          console.log('res::: ', res.toString());

          amountOutMin = res;
          sellArg[0] = res;
        }
      } else {
        // ---------- 买入逻辑 ----------
        if (
          parseUnits(Num, _spenToken.decimals) >
          parseUnits(walletConfig.SPENTOKENbArr[index], _spenToken.decimals)
        ) {
          // if (BigInt(Num) > BigInt(walletConfig.SPENTOKENbArr[index])) {
          const msg = `${addressHand(wallet.account.address)} 买入金额超出钱包可用余额，跳过该钱包`;
          logHandler ? logHandler(msg, "red") : Notification.Error(msg);
          return;
        }
        // 解析买入金额
        value = parseUnits(Num.toString(), _spenToken.decimals);
        console.log('value::: ', value);

        amountIn = value

        // 处理非主代币的参数格式
        if (!isSpenMianToken) {
          buyArg = [value, ...buyArg];
          value = 0n;
        }

        // 计算滑点
        spendAmount = isSpenMianToken ? value : buyArg[0];

        if (_isSlippage) {
          const res = await calculateSlippageAmount(
            buyPaths,
            publicClient,
            spendAmount,
            isBuy,
            poolKeyArray,
            extraValue,
          );
          amountOutMin = res;

          if (isSpenMianToken) {
            buyArg[0] = res;
          } else {
            buyArg[1] = res;
          }
        }
      }
      // 3. 执行交换操作 (公共逻辑)
      const res = await executeSwapWithFee({
        wallet,
        publicClient,
        path: swapPath,
        needsApproval: !tokenIsA[index],
        value,
        amountIn,
        isSpenMianToken,
        isBuy: isBuy,
        amountOutMin,
        spendAmount,
        sellAmount: !isBuy ? amountIn : undefined, // 仅卖出时传sellAmount
        poolKeyArray: poolKeyArray,
      });

      console.log('isBuy::: ', isBuy, res);

      if (logHandler) {
        logHandler(`${addressHand(wallet.account.address)}交易已打包上链`)
      } else {
        Notification.Success(`${addressHand(wallet.account.address)}交易已打包上链`);
      }
      const logMsg = isBuy
        ? `${addressHand(wallet.account.address)
        } ${Lang.q30} `
        : `${addressHand(wallet.account.address)} ${Lang.q38} `;

      // 监听交易最终结果
      waitForTransactionReceipt(wagmiConfig, {
        hash: res,
      })
        .then((result) => {
          if (result.status === 'success') {

            const msg = `${logMsg} `;
            if (logHandler) {
              logHandler(msg, Green, res, 1);
            } else {
              Notification.Success(msg);
            }
          } else {
            const failMsg = isBuy
              ? `${addressHand(wallet.account.address)} ${Lang.q31} `
              : `${addressHand(wallet.account.address)} ${Lang.q39} `;
            const msg = `${failMsg}`;
            if (logHandler) {
              logHandler(msg, ERROR, res, 1);
            } else {
              Notification.Error(msg);
            }
          }
        })
        .catch((err) => {
          console.log('waitForTransactionReceipt error::: ', err);
          const failMsg = `${addressHand(wallet.account.address)} ${isBuy ? Lang.q31 : Lang.q39}${errorHandler(err)}`;
          const msg = `${failMsg} `;
          if (logHandler) {
            logHandler(msg, ERROR, res, 1);
          } else {
            Notification.Error(msg);
          }
        });
        console.log('1111::: ', 1111);
    } catch (error) {
      console.log('error::: ', error);
      const errorMsg = errorHandler(error)
      logHandler ? logHandler(errorMsg, "red") : Notification.Error(errorMsg);
    }
  };
  return executeSwapSingle;
};

